export default "__VITE_ASSET__312f4399__"